module.exports = __webpack_public_path__ + "static_assets/media/bell10.ff41b1f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/bell10.mp3
// module id = 1gDR
// module chunks = 40